/* import __COLOCATED_TEMPLATE__ from './assign-to-team.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { closeModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'SH-c-assign-to-team-modal';

class AddToTeamModalComponent extends Component {
  @service session;

  @tracked updatedTeamId = null;
  @tracked updatedTeamValue = '';
  @tracked userCompanyTeams = [];

  get className() {
    return CLASS_NAME;
  }

  get teamOptions() {
    return [
      ...this.userCompanyTeams.map(team => ({
        key: team.name,
        id: team.id,
      })),
    ];
  }

  get saveDisabled() {
    return this.userCompanyTeams.length === 0
      || this.updatedTeamId === null
      || this.args.model.dropdownOptionsTask.isRunning
      || this.args.model.confirmAction.isRunning;
  }

  get cancelDisabled() {
    return this.args.model.confirmAction.isRunning;
  }

  @action
  handleDismiss() {
    closeModal(this);
  }

  @action
  handleDropdownOptionClick(option) {
    this.updatedTeamValue = option.key;
    this.updatedTeamId = option.id;
  }

  @action
  handleSave() {
    const { assignment } = this.args.model;
    const { updatedTeamId } = this;

    this.args.model.confirmAction.perform(assignment, updatedTeamId);
    closeModal(this);
  }

  constructor() {
    super(...arguments);

    const { currentUser } = this.session;

    this.args.model.dropdownOptionsTask.perform(currentUser).then((teams) => {
      this.userCompanyTeams = teams;

      // set default to first option
      if (teams.length > 0) {
        const firstTeam = teams.firstObject;
        this.updatedTeamId = firstTeam.id;
        this.updatedTeamValue = firstTeam.name;
      }
    });
  }
}

export default AddToTeamModalComponent;
